import TextIcon from '@mui/icons-material/TextFields';
import TextList from './TextList';
import { ShowText } from './ShowText';

export default {
      list: TextList,
      show: ShowText,
      icon: TextIcon,
}